"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionsValidator = actionsValidator;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * TODO: This code is very similar to the action proptype validator used in the Modal.
 * At some point, it might be good to co-locate these shared pieces of logic.
 */


function requiredActionsValidator(props, propName, componentName) {
  var actions = props[propName];

  if (!Array.isArray(actions) || actions.length < 1 || actions.length > 2) {
    return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(componentName, "`, expected an array with one or two options. Validation failed."));
  }

  _propTypes.default.checkPropTypes({
    actions: _propTypes.default.arrayOf(_propTypes.default.shape({
      onClick: _propTypes.default.func.isRequired,
      text: _propTypes.default.string.isRequired
    })).isRequired
  }, props, propName, componentName);

  return null;
}

function actionsValidator(props, propName, componentName) {
  /* istanbul ignore next */
  if (process.env.NODE_ENV !== 'production') {
    var actions = props[propName];

    if (actions === null || actions === undefined) {
      return null;
    }

    return requiredActionsValidator(props, propName, componentName);
  }

  return null;
}

actionsValidator.isRequired = requiredActionsValidator; // eslint-disable-next-line import/prefer-default-export